/* eslint-disable react/jsx-props-no-spreading */
import React, { PureComponent } from 'react';
import AsyncReactSelect from 'react-select/async';

class Select extends PureComponent {
	render() {
		const { props } = this;

		return (
			<AsyncReactSelect
				{...props}
			/>
		);
	}
}

Select.defaultProps = {
	className       : 'react-select',
	classNamePrefix : 'react-select',
};

export default Select;
